export function parseMarkdown(content) {
  // Extract title from the first heading
  const titleMatch = content.match(/^#\s+(.+)$/m);
  const title = titleMatch ? titleMatch[1] : 'Untitled';
  
  const lessonNumber = extractLessonNumber(title);
  const slug = generateSlug(title);
  
  return {
    frontmatter: {
      title,
      lessonNumber,
      slug
    },
    content: content
  };
}

export function extractLessonNumber(title) {
  const match = title.match(/Lesson (\d+\.\d+)/);
  return match ? match[1] : null;
}

export function generateSlug(title) {
  return title
    .toLowerCase()
    .replace(/lesson \d+\.\d+:\s*/, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function sortLessonsByNumber(lessons) {
  return lessons.sort((a, b) => {
    const aNum = parseFloat(a.frontmatter.lessonNumber || '0');
    const bNum = parseFloat(b.frontmatter.lessonNumber || '0');
    return aNum - bNum;
  });
}

export function getNextLesson(lessons, currentSlug) {
  const sortedLessons = sortLessonsByNumber(lessons);
  const currentIndex = sortedLessons.findIndex(lesson => lesson.frontmatter.slug === currentSlug);
  return currentIndex >= 0 && currentIndex < sortedLessons.length - 1 
    ? sortedLessons[currentIndex + 1] 
    : null;
}

export function getPreviousLesson(lessons, currentSlug) {
  const sortedLessons = sortLessonsByNumber(lessons);
  const currentIndex = sortedLessons.findIndex(lesson => lesson.frontmatter.slug === currentSlug);
  return currentIndex > 0 
    ? sortedLessons[currentIndex - 1] 
    : null;
}

export function searchLessons(lessons, query) {
  const searchTerm = query.toLowerCase();
  return lessons.filter(lesson => {
    const title = (lesson.frontmatter.title || '').toLowerCase();
    const content = lesson.content.toLowerCase();
    return title.includes(searchTerm) || content.includes(searchTerm);
  });
}